import React, { useState } from "react";

const DropPage = () => {
  const [files, setFiles] = useState([]);

  const handleFileUpload = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    setFiles([...files, ...uploadedFiles]);
  };

  return (
    <div className="drop-container">
      <h2>Drop</h2>
      <div className="drop-options">
        <label className="drop-box">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            hidden
          />
          <span>📷 Image</span>
        </label>
        <label className="drop-box">
          <input
            type="file"
            accept="video/*"
            onChange={handleFileUpload}
            hidden
          />
          <span>🎥 Video</span>
        </label>
        <label className="drop-box">
          <input
            type="file"
            accept="audio/*"
            onChange={handleFileUpload}
            hidden
          />
          <span>🎵 Audio</span>
        </label>
        <label className="drop-box">
          <input
            type="file"
            accept="image/gif"
            onChange={handleFileUpload}
            hidden
          />
          <span>🖼️ GIF</span>
        </label>
      </div>

      <div className="preview-section">
        {files.length > 0 && <h3>Uploaded Files</h3>}
        <div className="preview-list">
          {files.map((file, index) => (
            <div key={index} className="preview-item">
              {file.type.startsWith("image") ? (
                <img src={URL.createObjectURL(file)} alt={file.name} />
              ) : file.type.startsWith("video") ? (
                <video controls src={URL.createObjectURL(file)} />
              ) : file.type.startsWith("audio") ? (
                <audio controls src={URL.createObjectURL(file)} />
              ) : (
                <p>{file.name}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DropPage;
